import { useEffect, useState } from 'react';

/**
 * The window's width in CSS px, kept current across resizes and rotation:
 * the Building view's "screen under 768 px" check (`twinAvailability`).
 * Null where there is no window, which skips that one check rather than
 * guessing.
 */
export function useViewportWidth(): number | null {
  const [width, setWidth] = useState<number | null>(() =>
    typeof window === 'undefined' ? null : window.innerWidth,
  );
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return width;
}
